import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { CANT_FIND_BANK_MODAL_ID } from './constants';

export interface CantFindBankButtonHook {
  onClick: () => void;
}

export default function useCantFindBankButton(): CantFindBankButtonHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(
    () => showModal(CANT_FIND_BANK_MODAL_ID),
    [showModal],
  );

  return {
    onClick,
  };
}
